import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Input } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = (props) => {
  const { className, onChange, style, ...rest } = props;

  return (
    <Paper {...rest} style={style}>
      <SearchIcon />
      <Input {...rest} disableUnderline onChange={onChange} />
    </Paper>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
};

export default SearchInput;
